import Vue from 'vue'
import VueI18n from 'vue-i18n'

// element-ui DatePicker
import DatePicker from 'element-ui/lib/date-picker'
// element-ui lang
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementKoLocale from 'element-ui/lib/locale/lang/ko'

// app locales lang
import enLocale from './locales/en'
import zhLocale from './locales/zh'
import koLocale from './locales/ko'

// element-ui lang locale
import ElementLocale from 'element-ui/lib/locale'

import { default_lang } from '../../common/function/system' 

// const elementLocale = {
//   en: elementEnLocale,
//   ko: elementKoLocale,
//   zh: elementZhLocale
// }

Vue.use(VueI18n)
Vue.use(DatePicker)

// function loadLocaleMessages () {
  
//   const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)

//   const messages = {}

//   locales.keys().forEach(key => {

//     const matched = key.match(/([A-Za-z0-9-_]+)\./i)

//     if (matched && matched.length > 1) {
//       const locale = matched[1]
//       messages[locale] = {
//         ...locales(key),
//         ...elementLocale[locale]
//       }
    
//     }
    
//   })

//   return messages
// }


const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  ko: {
    ...koLocale,
    ...elementKoLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}


const i18n = new VueI18n({
  locale: default_lang,
  fallbackLocale: default_lang,
  messages: messages
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
